import type { TenantConfig } from '@/types/TenantConfig'

export const motorsport: TenantConfig = {
  logo: 'assets/motorsport/static/logo.svg',
  titleInsideContentColumn: true,
  teaserImageSize: {
    height: 200,
  },
  componentOptions: {
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/motorsport/static/complete.jpeg',
      },
      completedContentOffset: {
        desktop: '-200px',
        mobile: '-150px',
      },
    },
    stripeCreditCard: {
      fontFaceStylesheet: '/assets/motorsport/static/fonts.css',
    },
  },
}
